<template>
  <div class="sitemap">
    <h3>Hosting &amp; Domains</h3>
    <div class="row">
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/webhosting">Web Hosting</router-link>
        </p>
      </div>
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/sitebuilder">Free Site Builder</router-link>
        </p>
      </div>
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/domains">Domain Registration</router-link>
        </p>
      </div>
    </div>

    <h3>Mailing List / Newsletter Service</h3>
    <div class="row">
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/mailinglists">Mailing List / Newsletters</router-link>
        </p>
      </div>
    </div>

    <h3>Free Web Tools</h3>
    <div class="row">
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/blogs">Blogs / Journals</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/messageforums">Message Forums</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/photoalbums">Photo Albums</router-link>
        </p>
      </div>
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/contactforms">Contact Forms</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/guestbooks">Guestbooks</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/onlinecalendars">Online Calendars</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/onlinestore">Online Stores</router-link>
        </p>

      </div>
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/countersitestats">Counters / Site Stats</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/passwordprotect">Password Protect</router-link>
        </p>
      </div>
    </div>

    <h3>General</h3>
    <div class="row">
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/register">Join Bravenet</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/lostpassword">Lost Password</router-link>
        </p>

      </div>
      <div class="col-4 col-lg-4">
        <!--p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="pro/pricelist.php">Professional Price List</router-link>
        </p-->
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <a href="https://www.bravenet.com/global/abuse.php">Report Service Abuse</a>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="global/subscribe.php">Bravenet Newsletters</router-link>
        </p>
      </div>
      <div class="col-4 col-lg-4">
       <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/privacy-policy">Privacy Policy</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="/terms">Terms of Use</router-link>
        </p>
      </div>
    </div>

    <h3>Help Center</h3>
    <div class="row">
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <router-link to="help.php">Bravenet Help Center</router-link>
        </p>
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <a href="http://wiki.bravesites.com/">Site Builder Wiki</a>
        </p>
      </div>
      <div class="col-4 col-lg-4">
        <p>
          <md-icon>keyboard_arrow_right</md-icon> <a href="http://www.bravenet.com/help/postquestion.php">Contact Support Staff</a>
        </p>
      </div>
      <div class="col-4 col-lg-4">
       <p>
          <md-icon>keyboard_arrow_right</md-icon> <a href="http://wiki.bravenet.com/">Bravenet Wiki</a>
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.sitemap {
  h3 {
    font-size: 20pt;
    margin-bottom: 10px;
    margin-top: 0;
  }

  .row {
    display: flex;
    > div {
      flex: 30%;
      p {
        margin: 20px 0;
        font-size: 13px;
      }
    }
  }
}

</style>
<script>
import style from 'components/sitemap.scss'
export default {
}
</script>

